import { render, staticRenderFns } from "./DigitalSignatureRecords.vue?vue&type=template&id=1212afcf&"
import script from "./DigitalSignatureRecords.vue?vue&type=script&lang=js&"
export * from "./DigitalSignatureRecords.vue?vue&type=script&lang=js&"
import style0 from "./DigitalSignatureRecords.vue?vue&type=style&index=0&id=1212afcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports